/*
 * This file is part of ng2-json-editor.
 * Copyright (C) 2018 CERN.
 *
 * ng2-json-editor is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License as
 * published by the Free Software Foundation; either version 2 of the
 * License, or (at your option) any later version.
 *
 * ng2-json-editor is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with ng2-json-editor; if not, write to the Free Software Foundation, Inc.,
 * 59 Temple Place, Suite 330, Boston, MA 02111-1307, USA.
 * In applying this license, CERN does not
 * waive the privileges and immunities granted to it by virtue of its status
 * as an Intergovernmental Organization or submit itself to any jurisdiction.
*/

import { Pipe, PipeTransform } from '@angular/core';

import { JSONSchema } from '../interfaces';
import { CompareKeysBySchemaService } from '../services';


export class SortKeysBySchemaPipe implements PipeTransform {

  constructor(private compareKeysBySchemaService: CompareKeysBySchemaService) { }

  /**
   * WARN: uses Array.sort hence mutates the first param
   *
   * @param keys keys in the object
   * @param schema schema of the parent object
   */
  transform(keys: Array<string>, schema: JSONSchema): Array<string> {
    return keys
      .sort((a, b) => this.compareKeysBySchemaService.compare(a, b, schema));
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'sortKeysBySchema',
  pure: false,
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: CompareKeysBySchemaService, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
